/* Component Dependencies */
var partnerLogoTemplate = require('templates/partnerLogo.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'partnerLogo',
  template: {
    'partnerLogo': partnerLogoTemplate
  }
});
